var lib_core = require("lib-core");

var SymbolInstanceData = require("../../component/symbolInstanceData.js");

var SchematicData = function () {
    var self = this;

    this.makeObservableTreeNode();

    this.schematicElements  = this.set("schematicElements", true);
    this.schematicNets      = this.set("schematicNets", true);
    this.labels             = this.set("labels", true);
    this.drawings           = this.list("drawings", true);

    this.buildSchematicTerminalNetMap();
};
lib_core.mixin(SchematicData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(SchematicData, "SchematicData");

module.exports = SchematicData;

SchematicData.prototype.getSchematicTerminalInstance = function (logicTerminalInstance) {
    var theSchematicTerminalInstance = null;
    this.schematicElements.forEach(function (schematicElement) {
        var tmp = schematicElement.getSchematicTerminalInstance(logicTerminalInstance);
        if(tmp)
            theSchematicTerminalInstance = tmp;
    });
    return theSchematicTerminalInstance;
};

SchematicData.prototype.getSchematicNet = function (logicNetData) {
    var theSchematicNet = null;
    this.schematicNets.forEach(function (schematicNet) {
        if(schematicNet.netData() === logicNetData)
            theSchematicNet = schematicNet;
    });
    return theSchematicNet;
};

SchematicData.prototype.buildSchematicTerminalNetMap = function () {
    var self = this;

    this.schematicTerminalNetMap = new lib_core.ObservableMap();

    var addNet = function (net) {
        net.terminals.forEach(function (terminal) {
            self.schematicTerminalNetMap.put(terminal, net);
        });
        net.terminals.onAdd(self, function (key, terminal) {
            self.schematicTerminalNetMap.put(terminal, net);
        });
        net.terminals.onRemove(self, function (key, terminal) {
            self.schematicTerminalNetMap.remove(terminal);
        });
    };
    var removeNet = function (net) {
        net.terminals.forEach(function (terminal) {
            self.schematicTerminalNetMap.remove(terminal, net);
        });
    };

    this.schematicNets.forEach(function (net) {
        addNet(net);
    });
    this.schematicNets.onAdd(this, function (key, net) {
        addNet(net);
    });
    this.schematicNets.onRemove(this, function (key, net) {
        removeNet(net);
    });
};

SchematicData.prototype.sanityCheck = function() {
    lib_core.ObservableTreeNode.sanityCheck.call(this);

    var netlist = this.parent().netlist();

    var count_sub_symbols = 0;
    netlist.componentInstances.forEach(function(componentInstance) {
        count_sub_symbols += componentInstance.composedSymbol().symbolInstances.size();
    });
    console.assert(count_sub_symbols === this.schematicElements.size(), "Wrong number of schematic elements");
};

SchematicData.prototype.getSchematicElement = function(symbolInstance) {
    console.assert(symbolInstance.template() instanceof SymbolInstanceData);
    var theSchematicElement = null;
    this.schematicElements.forEach(function(schematicElement) {
        if(schematicElement.ancestor() === symbolInstance)
            theSchematicElement = schematicElement;
    });
    return theSchematicElement;
};
